<template>
  <v-container
    v-if="loading"
    class="my-3"
  >   
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          color="grey lighten-2"
          class="mx-auto"
          type="table-tbody"
        />
      </v-col>
    </v-row>
  </v-container>

  <v-container v-else>
    <v-row no-gutters>
      <v-col
        cols="12"
      >
        <my-claim-entitlement-table-list
          ref="entitlement"
          :claim-entitlements="claimEntitlements"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="$vuetify.breakpoint.mdAndUp"
      no-gutters
      class="mt-3"
    >
      <v-col cols="12">
        <my-claim-request-table-list
          ref="request"
          :employee="employee"
          :claim-entitlements="claimEntitlements"
          @updated="loadData"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      MyClaimEntitlementTableList: () => import('@/components/hris/my-claim/entitlement/TableList'),
      MyClaimRequestTableList: () => import('@/components/hris/my-claim/request/TableList'),
    },
    metaInfo () {
      return {
        title: 'Claim',        
      }
    },
    data () {
      return {
        claimEntitlements: [],
        loading: false,
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
    watch: {
      employee: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadData()
          }
        },
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.claimTypes().listEmployeeClaims(this.employee.employee_uid)
          .then((claimEntitlements) => {
            this.claimEntitlements = claimEntitlements.data
            this.claimEntitlements.sort((a, b) => {
              return a.name > b.name ? 1 : -1
            })

            this.claimEntitlements = this.claimEntitlements.map(ett => {
              if (ett.claim_entitlement_settings && ett.claim_entitlement_settings.claim_entitlements && ett.claim_entitlement_settings.claim_entitlements.length > 0) {
                const claimEnts = ett.claim_entitlement_settings.claim_entitlements

                const updatedSettings = claimEnts.map(ce => {
                  const pendingAmt = (ett.pending_claims || [])
                    .filter(claim => {
                      if (claim.entitlement_date_to_deduct) {
                        return claim.entitlement_date_to_deduct === ce.start_date
                      } else {
                        if (!claim.receipt_date) return false
                        const receipt = new Date(claim.receipt_date)
                        const start = new Date(ce.start_date)
                        const end = new Date(ce.end_date)
                        return receipt >= start && receipt <= end
                      }
                    })
                    .reduce((sum, claim) => sum + claim.total_amount, 0)

                  return {
                    ...ce,
                    pending_amt: pendingAmt,
                  }
                })

                return {
                  ...ett,
                  claim_entitlement_settings: {
                    ...ett.claim_entitlement_settings,
                    claim_entitlements: updatedSettings,
                  },
                }
              } else {
                return { ...ett }
              }
            })

            this.loading = false
          })
      },
    },
  }
</script>
